<!-- Site-wide widget (EPS-4567): mounted once per Vision page in TemplateSingleComponent. Renders nothing
     until triggered by a content-authored element carrying the `.raf-trigger` class (or an anchor whose href
     ends in `#raf-trigger`) — the CKEditor "Refer a Friend" button. Stays inert entirely when the
     `referAFriendConfig` global is unset, so the legacy Ambassador (MBSY) `#raf-trigger` id flow is untouched. -->
@if (visible()) {
  <refer-a-friend
    [screen]="screen()"
    [copy]="copy"
    [referralLink]="referralLink()"
    [loading]="loading()"
    [error]="error()"
    [designMode]="designMode"
    [selectedChannels]="selectedChannels"
    [shareMessage]="shareMessage"
    (submitEmail)="onSubmitEmail($event)"
    (retry)="onRetry()"
    (copyLink)="onCopyLink()"
    (closeModal)="onCloseModal()"
  ></refer-a-friend>
}
